import React from 'react';
import { ContainerTexto, Title, TitleContainer, Text, FixedAnchor } from '../styles';
import video from '../../../assets/video/solicitacao_de_retorno.mp4';
import { VideoPlayer } from 'components/_REFACTORED/VideoPlayer';
import { Anchor } from 'antd';


const Estoque: React.FC = () => {

  const { Link } = Anchor

  return (
    <>
      <ContainerTexto>
        <TitleContainer id="estoque-inicio">Estoque</TitleContainer>

        <VideoPlayer videoFile={video} />

        <Text>
          Em "Estoque" o usuário poderá consultar e exportar seus produtos em detalhes.
          Ele poderá ver todos seus produtos em estoque e acompanhar sua disponibilidade. Além
          disso, ele poderá solicitar o retorno de suas mercadorias disponíveis.
        </Text>

        <Title id="estoque-info">Informações Principais</Title>
        <Text>
          A tela conta com uma listagem com as informações de código interno do produto no Sankhya,
          código de referência do produto, inscrição estadual e depositante à quem aquele produto
          pertence, nome do produto, unidade do produto e total em estoque, para todos os produtos
          em estoque das inscrições estaduais selecionadas no cabeçalho, no centro de distribuição
          selecionado.
        </Text>

        <Title id="estoque-infoAdicionais">Informações adicionais</Title>

        <Text>
          Além disso, a expansão do produto conta com informações detalhadas sobre o produto para
          sua respectiva inscrição estadual, sendo estas o número da nota de entrada desse produto
          no Sankhya, o lote do produto, o tempo restante de armazenagem no contrato daquele
          produto, a data de validade do produto, o pagador da armazenagem daquele produto, se este
          produto possui nota de cobertura, a quantidade do produto disponível para retorno, bem
          como a quantidade já reservada para retirada, a quantidade indisponível e o total em
          estoque.
        </Text>

        <Title id="estoque-retorno">Solicitação de retorno</Title>

        <Text>
          Também na expansão do produto, o usuário poderá solicitar o retorno dessa mercadoria
          clicando no botão "Solicitar retorno" (o botão estará habilitado apenas para produtos
          cujas notas possuem quantidade disponível para solicitação).{' '}
        </Text>

        <Text>
          Ao iniciar o processo de solicitação de retorno, o usuário será apresentado a uma tela
          onde deverá informar a quantidade que deseja retornar, esta quantidade deve ser informada
          de acordo com o fracionamento do produto escolhido (esta informação está disponível no
          modal na interrogação ao lado do campo "Total"). O campo quantidade representa a
          quantidade de volumes a ser solicitado, enquanto o campo total informa a quantidade bruta
          que resulta dessa quantidade de volumes. Abaixo desses campos também é informada a
          quantidade disponível para retorno daquele produto para aquele lote e pagador.{' '}
        </Text>

        <Text>
          Após selecionar a quantidade desejada, o usuário deverá clicar no botão "Adicionar", que
          enviará o produto para a lista de mercadoria. Esta lista pode ser consultada a qualquer
          momento clicando no ícone que aparecerá no cabeçalho, ou no botão "Lista de retorno de
          mercadoria" acima da listagem da tela "Estoque".{' '}
        </Text>

        <Text>
          Quando o usuário terminar de adicionar os produtos que deseja solicitar o retorno, o
          usuário deverá clicar no botão "Continuar" dentro do carrinho, este o direciona para a
          tela de confirmação de retorno, onde o usuário deverá informar um endereço e um meio de
          entrega desses produtos, normalmente uma transportadora, e revisar as informações do(s)
          pedido(s).{' '}
        </Text>

        <Text>
          Nos endereços, o usuário poderá selecionar os endereços já cadastrados para as inscrições
          estaduais selecionadas no cabeçalho, e poderá cadastrar um novo endereço na aba "Cadastrar
          novo endereço", o novo endereço será associado apenas à inscrição estadual solicitante
          (inscrição marcada na nota cujo produto foi solicitado).{' '}
        </Text>

        <Text>
          Nas transportadoras, o usuário poderá selecionar as transportadoras já cadastradas para as
          inscrições estaduais selecionadas no cabeçalho e poderá cadastrar uma nova transportadora
          na aba "Transportadoras não cadastradas". A nova transportadora será associada apenas à
          inscrição estadual solicitante, similar ao novo endereço. Além disso, o usuário poderá
          optar por retirar sua própria mercadoria, nesse caso este deve selecionar a aba "Cliente
          retira".{' '}
        </Text>

        <Text>
          Após a conferência das informações, o(s) apontamentos do(s) endereço(s) e
          transportadora(s), o usuário poderá realizar a solicitação clicando em "Confirmar" no
          canto inferior direito da tela. Ele será apresentado com o(s) número(s) único(s) da(s)
          nota(s) gerada(s) no sistema, e receberá um e-mail confirmando a nova solicitação.
        </Text>

        <Text>
          Posteriormente o usuário receberá outros e-mails de atualização destas solicitações,
          conforme estas avançam nos processos. O usuário também poderá consultar suas solicitações
          na tela "Solicitações de Retorno".
        </Text>

        <Title id="estoque-exportacao">Exportação de dados</Title>
        <Text>
          A tela conta com uma exportação de estoque em detalhes para Excel e CSV, onde o usuário
          poderá salvar suas informações de estoque.
        </Text>

        <Title id="estoque-filtros">Filtros</Title>
        <Text>
          Por fim, a tela também conta com os filtros de produto, pagador da armazenagem,
          depositante, lote e dias para vencer.
        </Text>
      </ContainerTexto>

      <FixedAnchor>
        <Link title="Início" href='#estoque-inicio' />
        <Link title="Informações Principais" href='#estoque-info' />
        <Link title="Informações Adicionais" href='#estoque-infoAdicionais' />
        <Link title="Solicitação de retorno" href='#estoque-retorno' />
        <Link title="Exportação de dados" href='#estoque-exportacao' />
        <Link title="Filtros" href='#estoque-filtros' />
      </FixedAnchor>
    </>
  );
};

export default Estoque;
